import { atom } from 'jotai';
import { z } from 'zod';
import { createSSEConnection } from '~/lib/workflows/sseConnection';

export const notificationSchema = z.object({
  workflow_id: z.string(),
  task_states: z.record(z.unknown()),
  status: z.enum(['starting', 'running', 'completed', 'failed']),
  priority: z.enum(['low', 'medium', 'high']),
  started_at: z.string().refine((val) => !isNaN(Date.parse(val)), {
    message: 'Invalid datetime',
  }),
  title: z.string().nullable(),
  data: z.object({
    to_address: z.string().optional(),
    from_address: z.string().optional(),
    content: z.string().optional(),
    email_id: z.string().optional(),
    subject: z.string().optional(),
    conversation_id: z.string().optional(),
    type: z.string().optional(),
    event_type: z.string().optional(),
  }),
});

export type Notification = z.infer<typeof notificationSchema>;

export interface NotificationsState {
  notifications: Notification[];
  isLoading: boolean;
  error: string | null;
  connection: ReturnType<typeof createSSEConnection<Notification>>;
}

const initialState: NotificationsState = {
  notifications: [],
  isLoading: false,
  error: null,
  connection: createSSEConnection<Notification>(),
};

export const notificationsAtom = atom<NotificationsState>(initialState);
